import React, { Component } from "react";
import { mensajeExito } from "../../generico/MensajeSistemaToast"
import DataTable from 'react-data-table-component';
import DatosSocio from "../../generico/DatosSocio";
import { trackPromise } from 'react-promise-tracker';
import history from "../login/history";
import Popup from "react-popup";
import PrestamoService from "../../../services/pagos/PrestamoService";
import authService from "../../../services/login/auth.service";
import ConfigService from "../../../services/configuracion/ConfigService";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faFilePdf} from "@fortawesome/free-solid-svg-icons";

export default class PrestamoPaso4 extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    nroOperacion: undefined
  })

  componentDidMount() {
    
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  getColumn() {
    return [
      {
        name: "concepto",
        selector: row => row.concepto,
      },
      {
        name: "valor",
        selector: row => row.valor,
      }]
  }

  inicio = (e) => {
    //history.push('/pagoPrestamo');
    history.push(ConfigService.getPathByName("pagoPrestamo")?.url);
    window.location.reload();
  }

  obtenerDatos = (idPrestamo, cantCuotas, cuenta) => {

    trackPromise(
      PrestamoService.cuotasPagar(idPrestamo, "C", cantCuotas, cuenta)
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          //console.log(jsonData)
          if (jsonData.codRespuesta === "0") {
            this.setState({ nroOperacion: jsonData.numeroOperacion });
            mensajeExito("El Pago del Préstamo se Realizó Correctamente")

          }
          else {
            Popup.queue(this.notifiPopup("Info", jsonData.codDescripcion));
            this.props.previousStep();
          }
        }
        ).catch(function (error) {
          authService.logout()
          //console.log(error)
        }));
  }

  descargar = async () => {
    var datosCredito = this.props.datosCuenta;
    var capitalInteres = datosCredito[0].valor;
    var interesMora = datosCredito[1].valor;
    var otrosCargos = datosCredito[2].valor;
    var impuestos = datosCredito[3].valor;
    var total = this.props.moneda+". "+ datosCredito[4].valor;
    
    await trackPromise(
      PrestamoService.descagarComponente("Pago de Préstamos", this.state.nroOperacion, authService.getSocio().numeroSocio.trim() + " - " + authService.getSocio().nombreCompleto, this.props.prestamo, this.props.debito, "-", capitalInteres, interesMora, otrosCargos, impuestos, total)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");         
        })
        .catch(function (error) {
          console.log(error);
        })
    );

    this.setState({ listaFactura: true });
   // return listaFactura;
  };

  render() {
 
    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                  
                    <span className="title_text current">
                      Selección de Préstamo
                          </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    
                    <span className="title_text">
                      Datos de Pago
                          </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    
                    <span className="title_text">
                      Datos de Verificación
                          </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                  
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-md-8" style={{ textAlign: "end" }}>
            <p className="nro-operacion">
              Número de Operación: {this.state.nroOperacion}
            </p>
          </div>
        </div>
        <div className="row justify-content-md-center">
          <div className="col-md-8">
            <div className="form-group">
              <DatosSocio />
            </div>


            <div className="form-group">
              <label className="input-label">Prestamo N°:</label><br />
              <label className="input-label-bold">{this.props.prestamo}</label>
            </div>
            <div className="form-group">
              <label className="input-label">Cuenta débito:</label><br />
              <label className="input-label-bold">{this.props.debito}</label>
            </div>
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-md-8">
            <div className="row">
              <div className="table-responsive">
                <DataTable
                  noHeader={true}
                  columns={this.getColumn()}
                  data={this.props.datosCuenta}
                  dense={true}
                  noDataComponent="ingrese un número de contrato para mostrar la información"
                  responsive={true}
                  noTableHead={true} />
              </div>
            </div>
          </div>
        </div>
        <br />
        <hr />

        <div className="row">
          <div className="col-lg-6"></div>
          <div className="col-lg-3">
          <button
            className="btn btn-cu-quintary btn-consulta"
            onClick={this.inicio}> <FontAwesomeIcon icon={faArrowLeft} /> Ir al Inicio
        </button>
          </div>
          <div className="col-lg-3">
          <button className="btn btn-cu-primary" onClick={this.descargar}> <FontAwesomeIcon icon={faFilePdf} /> Descargar Comprobante</button>
          </div>
          
       
        </div>
      </div>
    );
  }
}